import { RubricCorporaPage } from '@/components/admin/evaluation-rubrics/rubric-corpora-page'

export function EvaluationRubricsPage() {
  return <RubricCorporaPage />
}
